import React from "react";
import { Paper, Typography, Box } from "@mui/material";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import { formatTime } from "../../../../../Helpers/missionHelper";
import config from "../../../../../config";

function TimerSection({
  timeLeft,
  canSubmit,
  title = "Time Left to Submit",
  variant = "large", // "large" for file upload, "small" for MCQ
  direction = "column",
}) {
  const isSmall = variant === "small";
  const isRow = direction === "row";

  return (
    <Paper
      elevation={4}
      sx={{
        flex: 1,
        p: isSmall ? (isRow ? 2 : 3) : { xs: 3, md: 5 },
        borderRadius: isRow? "8px" :5,
        display: "flex",
        flexDirection: direction,
        alignItems: isRow ? "flex-end" : "center",
        justifyContent: isRow ? "space-between" : "center",
        background: isRow ? "#f5f5f5" : "white",
        minWidth: isRow ? "auto" : 260,
        width: isRow ? "100%" : "auto",
        mb: { xs: 3, md: isRow ? 2 : 0 },
        boxShadow: "0 4px 32px 0 #b3b3b320",
        textAlign: isRow ? "left" : "center",
        gap: isRow ? 2 : 0,
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: isRow ? 2 : 0,
          flexDirection: isRow ? "row" : "column",
          flex: isRow ? 1 : "none",
        }}
      >
        <AccessTimeIcon
          sx={{
            fontSize: isSmall ? (isRow ? 40 : 40) : isRow ? 36 : 60,
            color: config.PRIMARY_COLOR,
            mb: isRow ? 0 : 1,
            flexShrink: 0,
          }}
        />
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: isRow ? "flex-start" : "center",
            gap: isRow ? 0.5 : 0,
          }}
        >
          <Typography
            variant="h6"
            sx={{
              mb: isRow ? 0 : 2,
              fontWeight: 700,
              fontSize: isRow ? "15px" : "inherit",
              lineHeight: 1.2,
            }}
          >
            {title}
          </Typography>
          {isRow && (
            <Typography
              sx={{
                fontFamily: "monospace",
                fontSize: isSmall ? "28px" : "36px",
                color: canSubmit ? "success.main" : "error.main",
                fontWeight: 900,
                letterSpacing: 1,
                lineHeight: 1,
                textShadow: canSubmit
                  ? "0 2px 12px #b3e6b3a0"
                  : "0 2px 12px #e57373a0",
              }}
            >
              {formatTime(timeLeft)}
            </Typography>
          )}
        </Box>
      </Box>

      {!isRow && (
        <>
          <Typography
            sx={{
              fontFamily: "monospace",
              fontSize: isSmall ? "48px" : { xs: "56px", md: "65px" },
              color: canSubmit ? "success.main" : "error.main",
              fontWeight: 900,
              letterSpacing: isSmall ? 1 : 2,
              lineHeight: 1,
              textShadow: canSubmit
                ? "0 2px 12px #b3e6b3a0"
                : "0 2px 12px #e57373a0",
              mb: 1,
            }}
          >
            {formatTime(timeLeft)}
          </Typography>
          <Typography sx={{ color: "#666", fontSize: 16, fontWeight: 400 }}>
            {canSubmit
              ? "Submit before the timer ends!"
              : "Submission time is over."}
          </Typography>
        </>
      )}

      {isRow && (
        <Typography
          sx={{
            color: "#666",
            fontSize: 14,
            fontWeight: 400,
            textAlign: "right",
            flexShrink: 0,
            maxWidth: "200px",
          }}
        >
          {canSubmit
            ? "Submit before the timer ends!"
            : "Submission time is over."}
        </Typography>
      )}
    </Paper>
  );
}

export default TimerSection;
